import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/matching.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Kundalimatching(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Kundali Matching"}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   Kundali Matching, also referred to as Kundali Milan, is an important practice in Vedic astrology to determine the compatibility of two individuals for marriage. It is believed that the alignment of their stars can significantly influence their compatibility, happiness, and longevity of the marriage
   </p>
    
<p>
<span className="fw-bolder">Guna Milan </span> The process involves comparing the 36 Gunas (attributes) that are derived from the birth charts. Each couple is given a Guna score; the higher the number of matched attributes, the more compatible the couple is deemed to be
</p><p>
<span className="fw-bolder">Manglik Dosh:</span> The presence of Manglik Dosh in either partner’s chart is carefully evaluated. If one person has this dosh, remedies or matched pairing with another Manglik partner may be suggested to minimize potential issues
</p><p>
<span className="fw-bolder">Ashta Kuta System:</span>  This system assesses eight aspects of the couple's horoscopes, each contributing to the overall compatibility score out of 36 points. These aspects include Varna (spiritual compatibility), Vashya (mutual attraction), Tara (destiny), Yoni (sexual compatibility), Graha Maitri (general compatibility and friendship), Gana (behavior compatibility), Rashi (zodiac compatibility), and Nadi (health compatibility).
</p><p>
<span className="fw-bolder">Comparative Analysis</span>  The astrologer Sanjay Bhargav compares the charts to assess various factors such as compatibility and dosh.
</p><p>
<span className="fw-bolder">Providing a Compatibility Score:</span> Based on the comparison, the astrologer assigns a Guna score and offers an analysis, suggesting whether the match is auspicious or if there are potential challenges that need remedies.
</p>
<p className="text-center"><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">Book an Appoitment to Consult </button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export { Kundalimatching} ;